import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import NewsletterSubscribeFeedback from '../../../shared/NewsletterSubscribeFeedback/NewsletterSubscribeFeedback';
import { useEconomicCalendarMacroHighlightsContent } from '../../../../hooks/useEconomicCalendarMacroHighlightsContent';
import { useNewsletterSubscribe } from '../../../../hooks/useNewsletterSubscribe';
import { NEWSLETTER_SOURCES } from '../../../../utils/newsletterSources';
import '../../../shared/NewsletterSubscribeFeedback/NewsletterSubscribeFeedback.css';
import './MacroHighlights.css';

const MacroHighlights = () => {
  const { content, isLoading } = useEconomicCalendarMacroHighlightsContent();
  const {
    email,
    setEmail,
    isSubmitting,
    isSuccess,
    formError,
    fieldError,
    handleSubmit,
  } = useNewsletterSubscribe(NEWSLETTER_SOURCES.ECONOMIC_CALENDAR);

  if (isLoading || !content) {
    return null;
  }

  const { title, text, buttonText, privacy } = content;

  return (
    <section className="macro-highlights">
      <div className="macro-highlights__inner">
        <Reveal className="macro-highlights__panel">
          <div className="macro-highlights__copy">
            <h2 className="macro-highlights__title">{title}</h2>
            {text ? <p className="macro-highlights__text">{text}</p> : null}
          </div>

          <form
            className="macro-highlights__form"
            onSubmit={handleSubmit}
            noValidate
          >
            <div className="macro-highlights__row">
              <label className="macro-highlights__field">
                <span className="macro-highlights__sr-only">Email address</span>
                <input
                  className={`macro-highlights__input${
                    fieldError ? ' newsletter-subscribe-input--error' : ''
                  }`}
                  type="email"
                  name="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="Enter your email"
                  autoComplete="email"
                  disabled={isSubmitting}
                />
              </label>
              <button
                type="submit"
                className="macro-highlights__button luxury-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Subscribing…' : buttonText}
              </button>
            </div>

            <NewsletterSubscribeFeedback
              formError={formError}
              fieldError={fieldError}
              isSuccess={isSuccess}
            />

            {privacy?.text ? (
              <p className="macro-highlights__privacy">
                {privacy.text}{' '}
                {privacy.linkText && privacy.linkUrl ? (
                  <Link to={privacy.linkUrl} className="macro-highlights__privacy-link">
                    {privacy.linkText}
                  </Link>
                ) : null}
              </p>
            ) : null}
          </form>
        </Reveal>
      </div>
    </section>
  );
};

export default MacroHighlights;
